import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './InternetRequirements.module.scss';

const InternetRequirements = ({ speed, connection }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="InternetRequirements"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.title}>
        <div className={CN.iconContainer}>
          <Icon variant="wifi" width="xl" />
        </div>
        {t('staffAndBusiness.userNetwork.hardwareInformation.section3Title')}
      </div>

      <div className={CN.content}>
        <div className={CN.boxSpeed}>
          {t('staffAndBusiness.userNetwork.hardwareInformation.speed')}
          <div className={CN.text}>{speed}</div>
        </div>
        <div className={CN.boxConnection}>
          {t('staffAndBusiness.userNetwork.hardwareInformation.connection')}
          <div className={CN.text}>{connection}</div>
        </div>
      </div>
    </div>
  );
};

export default InternetRequirements;
